<template>
  <div v-if="products && products.length > 0" id="company-display-products" class="d-flex flex-wrap">
    <div v-for="product in products" :key="product.uuid" class="product" :style="productStyles(product.product_images)" />
  </div>
</template>

<script>
export default {
  props: {
    products: { type: Array, require: true },
    productCount: { type: Number, default: 6 },
  },
  methods: {
    productStyles(productImages) {
      const img = productImages[0].imageLink;
      const size = `${100 / this.productCount}%`;
      return {
        width: size,
        "padding-bottom": size,
        "background-image": `url(${img})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#company-display-products {
  margin-left: -1rem;
  margin-right: -1rem;
  @media screen and (max-width: 600px) {
    justify-content: space-around;
  }

  .product {
    position: relative;
    border: 1px soild black;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 600px) {
      /* // ? couldn't figure out a better way than this... open to ideas tho */
      min-width: calc((100vw - 5.25rem) / 3);
      height: calc((100vw - 5.25rem) / 3);
      padding-bottom: 0 !important;
    }
    @media screen and (max-width: 390px) {
      /* // ? couldn't figure out a better way than this... open to ideas tho */
      min-width: calc((100vw - 4.25rem) / 3);
      height: calc((100vw - 4.25rem) / 3);
      padding-bottom: 0 !important;
    }
  }
}
</style>
